import { useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import { MessageCircle } from "lucide-react";

export default function CourseInterestModal({ course, onClose }) {
    const [name, setName] = useState("");
    const [contact, setContact] = useState("");

    const handleSendWhatsApp = (e) => {
        e.preventDefault();
        
        const textMessage = `Olá! Meu nome é ${name || "Cliente"}. Tenho interesse no curso "${course?.title}". Meu contato para retorno é: ${contact || "não informado"}.`;
        const waUrl = `https://wa.me/5585988885910?text=${encodeURIComponent(textMessage)}`;
        
        window.open(waUrl, "_blank", "noopener,noreferrer");
        onClose();
    };

    return (
        <Dialog
            open={!!course}
            onOpenChange={(o) => {
                if (!o) onClose();
            }}
        >
            <DialogContent
                data-testid="course-interest-modal"
                className="max-w-md border-gold/25 bg-ink-900 p-8 text-slate-100"
            >
                <DialogHeader>
                    <DialogTitle className="font-serif text-2xl font-medium text-slate-50">
                        {course ? course.title : ""}
                    </DialogTitle>
                    <DialogDescription className="text-sm font-light leading-relaxed text-slate-400">
                        Preencha seu nome e WhatsApp para iniciar a inscrição diretamente com nossa equipe.
                    </DialogDescription>
                </DialogHeader>

                <form onSubmit={handleSendWhatsApp} className="space-y-4">
                    <div>
                        <label htmlFor="interest-name" className="eyebrow text-[10px]">
                            Nome completo
                        </label>
                        <input
                            id="interest-name"
                            data-testid="course-interest-name-input"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Seu nome"
                            required
                            className="mt-2 w-full rounded-md border border-white/10 bg-ink-800 px-4 py-3 text-sm text-slate-100 placeholder:text-slate-500 focus:border-gold/50 focus:outline-none"
                        />
                    </div>
                    <div>
                        <label htmlFor="interest-contact" className="eyebrow text-[10px]">
                            WhatsApp para contato
                        </label>
                        <input
                            id="interest-contact"
                            data-testid="course-interest-contact-input"
                            value={contact}
                            onChange={(e) => setContact(e.target.value)}
                            placeholder="(85) 9 9999-9999"
                            required
                            className="mt-2 w-full rounded-md border border-white/10 bg-ink-800 px-4 py-3 text-sm text-slate-100 placeholder:text-slate-500 focus:border-gold/50 focus:outline-none"
                        />
                    </div>
                    <button
                        type="submit"
                        data-testid="course-interest-submit-button"
                        className="gold-btn w-full rounded-full px-6 py-3.5 text-sm font-semibold flex items-center justify-center gap-2"
                    >
                        <MessageCircle size={16} />
                        Enviar mensagem pelo WhatsApp
                    </button>
                </form>
            </DialogContent>
        </Dialog>
    );
}